import React from 'react'
import { motion } from 'framer-motion'
import { Heart } from 'lucide-react'

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 px-4 safe-area-bottom">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* 应用信息 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-semibold mb-4">漫时光</h3>
            <p className="text-gray-400 leading-relaxed">
              专业的漫画阅读应用，为您提供最佳的阅读体验。
              支持多种格式，智能推荐，离线阅读等功能。
            </p>
          </motion.div>


         
        </div>

        {/* 分隔线 */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
              className="text-gray-400 text-sm mb-4 md:mb-0"
            >
              © 2025 漫时光. 保留所有权利.
            </motion.p>
            
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
              className="flex items-center space-x-2 text-gray-400 text-sm"
            >
              <span>Made with</span>
              <Heart className="w-4 h-4 text-red-500" />
              <span>for our users</span>
            </motion.div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
